import React, { useState } from 'react';
import { Button, Container, Group, Stack } from '@mantine/core';
import { modals } from '@mantine/modals';

export type PickedRecord = { id: string; name: string };

export type PickRecordModalProps = {
	modalId: string;
	/** A search that reports the chosen record, or none. */
	search: (onPicked: (record: PickedRecord | undefined) => void) => React.ReactNode;
	onPicked: (record: PickedRecord) => void;
};

/** Picks one record with an existing search, and only reports it: nothing is saved here. */
export default function PickRecordModal(props: PickRecordModalProps) {
	const { modalId, search, onPicked } = props;
	const [picked, setPicked] = useState<PickedRecord | undefined>(undefined);

	const handlePick = () => {
		if (picked) {
			onPicked(picked);
		}
		modals.close(modalId);
	};

	return (
		<Container>
			<Stack>
				{search(setPicked)}
				<Group justify="flex-end" mt="md">
					<Button type="button" variant="subtle" onClick={() => modals.close(modalId)}>
						Cancel
					</Button>
					<Button type="button" disabled={!picked} onClick={handlePick}>
						Choose
					</Button>
				</Group>
			</Stack>
		</Container>
	);
}
